<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size lg_size">
            <a href="javascript:" class="ui_close" @click="btnClose"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis maintit">
                    <i>{{ getTitle }}</i>
                </dt>
                <dd>
                    <div class="view_cont">
                        <div class="view_info">
                            <div class="view_category" v-if="typeof detail.PRD_CATEGORY_NM1 !== 'undefined'">
                                {{ detail.PRD_CATEGORY_NM1 }} 
                                <em v-if="typeof detail.PRD_CATEGORY_NM2 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM2 }} 
                                <em v-if="typeof detail.PRD_CATEGORY_NM3 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM3 }}
                            </div>
                        </div>
                        <dl class="view_subject">
                            <dt class="subject">
                                <em v-if="detail.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                <em v-else-if="detail.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                {{ detail.KNOWLEDGE_TITLE | refTitle | decodeXSS }}
                            </dt>
                            <dd class="desc">
                                <span class="desc_Regist">
                                    <em>{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</em>
                                    {{ detail.REG_USER }} ({{ detail.REG_DT }})
                                </span>
                                <span class="desc_modify">
                                    <em>{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</em>
                                    {{ detail.MODF_USER }} ({{ detail.MODF_DT }})
                                </span>
                            </dd>
                        </dl>

                        <!-- tab -->
                        <div class="view_desc">
                            <!-- 200420수정 S -->
                            <!-- SCMS Contents 의 경우, Symptom 및 Serial 등 추가 항목 -->
                            <table v-if="isSCMS" class="data_table_ty2 mb-20">
                                <colgroup>
                                    <col width="20%">
                                    <col width="30%">
                                    <col width="20%">
                                    <col width="*">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                                        <td colspan="3">
                                            <ul class="in_dotlist" v-if="symptomList.length === 0">
                                                <li>&nbsp;</li>
                                            </ul>
                                            <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                                <li>{{ symptom.C_CODE_T_INFO }} > {{ symptom.CODE_T_INFO }}</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                                        <td>
                                            <ul class="in_dotlist">
                                                <li v-if="typeof(detail.MANUFACTURE_S_DT) !== 'undefined'">
                                                    {{ (detail.MANUFACTURE_S_DT + '01') | dateFormat('MMM.YYYY') }} ~ {{ (detail.MANUFACTURE_E_DT + '01') | dateFormat('MMM.YYYY') }}
                                                </li>
                                            </ul>
                                        </td>
                                        <th class="text_left">{{ $t('FIELD.QNA.SERIAL.NUMBER') }}</th>
                                        <td>
                                            <ul class="in_dotlist" v-if="serialList.length === 0">
                                                <li>&nbsp;</li>
                                            </ul>
                                            <ul class="in_dotlist" v-else v-for="serial in serialList">
                                                <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E}}</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                                        <td>{{ getGuideTypeName }}</td>
                                        <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                                        <td>{{ getDefectTypeName }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- //200420수정 E -->


                            <div class="tab_wrap">
                                <ul class="tab_menu_02 tab_menus">
                                    <li class="on"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                                </ul>
                                <div class="tab_contents">
                                    <div class="tab_cont" v-html="detail.KNOWLEDGE_DESC" />
                                </div>
                            </div>

                            <div v-if="modelList.length > 0" class="tab_wrap">
                                <ul class="tab_menu_02 tab_menus">
                                    <li class="on"><a href="javascript:">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}</a></li>
                                </ul>
                                <div class="tab_contents">
                                    <div class="tab_cont">
                                        <!-- Grid -->
                                        <div class="grid_wrap">
                                            <table class="grid_table">
                                                <colgroup>
                                                    <col width="30%">
                                                    <col width="30%">
                                                    <col width="*">
                                                </colgroup>
                                                <thead>
                                                    <tr class="text_center">
                                                        <th>{{ $t('FIELD.GLOBAL.MODEL.CODE') }}</th>
                                                        <th>{{ $t('FIELD.GLOBAL.MODEL') }}</th>
                                                        <th>{{ $t('FIELD.GLOBAL.MARKETING.NAME') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="text_center">
                                                    <tr v-for="model in modelList" :key="model.MODEL_ID">
                                                        <td>{{ model.MODEL_ID }}</td>
                                                        <td>{{ model.MODEL_NM }}</td>
                                                        <td>{{ model.NMMODEL }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="partsList.length > 0" class="tab_wrap">
                                <ul class="tab_menu_02 tab_menus">
                                    <li class="on"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a></li>
                                </ul>
                                <div class="tab_contents">
                                    <div class="tab_cont">
                                        <!-- Grid -->
                                        <div class="grid_wrap">
                                            <table class="grid_table">
                                                <colgroup>
                                                    <col width="*">
                                                    <col width="35%">
                                                </colgroup>
                                                <thead>
                                                    <tr class="text_center">
                                                        <th>{{ $t('FIELD.GLOBAL.PARTS.CODE') }}</th>
                                                        <th>{{ $t('FIELD.GLOBAL.PARTS.TYPE') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="text_center">
                                                    <tr v-for="parts in partsList" :key="parts.PARTS_SEQ">
                                                        <td>{{ parts.PARTS_CODE }}</td>
                                                        <td>{{ parts.PARTS_TYPE }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab_wrap">
                                <ul class="tab_menu_02 tab_menus">
                                    <li class="on"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}</a></li>
                                </ul>
                                <div class="tab_contents">
                                    <div class="tab_cont">
                                        <!-- Version Tab -->
                                        <table class="data_table">
                                            <colgroup>
                                                <col width="15%">
                                                <col width="15%" class="pc_only">
                                                <col width="25%" class="pc_only">
                                                <col width="*">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>{{ $t('FIELD.GLOBAL.VERSION') }}</th>
                                                    <th class="pc_only">{{ $t('FIELD.GLOBAL.DATE') }}</th>
                                                    <th class="pc_only">{{ $t('FIELD.GLOBAL.EDITOR') }}</th>
                                                    <th>{{ $t('FIELD.GLOBAL.DETAILS') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody class="text_center">
                                                <tr v-if="versionList.length > 0" v-for="(version, idx) in versionList">
                                                    <td>Ver.{{ version.VERSION_NO }}</td>
                                                    <td class="pc_only">{{ version.MODF_DT }}</td>
                                                    <td class="pc_only">{{ version.MODF_USER }}</td>
                                                    <td class="text_left">{{ version.MODF_REASON | decodeXSS }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="btnClose">{{ $t('BUTTON.GLOBAL.CLOSE') }}</a>
                            <a href="javascript:" class="btn_blue" @click="btnPrint">{{ $t('BUTTON.GLOBAL.PRINT') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                                  from 'vue';
import { mapGetters }                       from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import axios                                from 'axios';
import qs                                   from 'query-string';

import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import CrossEditorViewer                    from '~c/CrossEditorViewer';
import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';

import ApprovalHistoryPopup                 from '~c/popup/ApprovalHistoryPopup';
import RequestSharingToPopup                from '~vb/common/RequestSharingToPopup';
import KnowledgeVersionDetailPopup          from './KnowledgeVersionDetailPopup';

const SCMS_CONTENTS_CD = [
    'SB',   // Service Bulletin
    'RT',   // Repair Tip
];

const fetchDetail = (knowledgeId, boardId) => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/knowledgeDetail.skp`,
    qs.stringify({ KNOWLEDGE_ID: knowledgeId, BOARD_ID: boardId }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'KnowledgeDetailPopup',
    props : {
        KNOWLEDGE_ID:       { required: true },
        BOARD_ID:           { },
        title:              { },
        rtnFunc:            { type: Function }
    },
    data() {
        return {
            isLoading : true,
            pageTitle: SDLUtil.getMsgProp('BUTTON.GLOBAL.PRINT'),
            window: { width: 0, height: 0 },

            strSymptom: [],
            modelList: [],
            modelColumnName: [],
            partsList: [],
            symptomList: [],
            serialList: [],
            satisfaction: [],
            attachImg: [],
            detail: {},
            attach: [],
            verifyList: [],
            versionList: [],
            isPrevious: false,
            isFavorite: false,
            isRepair: false,
            isSCMS: false,

            isShare: false,
            isAllowSharing: false,
            distTarget: '',

            reloadModel: false,
            reloadParts: false,

            options: {
                scrollY: true,
                minBodyHeight: 80,
                bodyHeight: 265
            },
            pageOptions: {
                useClient: true,
                perPage: 20
            },

            uploadId: 'download_' + String(this.knowledgeId),
            serviceType: 'common'
        }
    },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
        }),
        getKnowledgeId() {
            return this.KNOWLEDGE_ID;
        },
        getBoardId() {
            return this.BOARD_ID;
        },
        getTitle() {
            return this.title || this.pageTitle;
        },
        getBoardCreationYN() {
            return store.getters.getParams.creationYn || 'N';
        },
        getDefectTypeName() {
            let defectType = this.detail.DEFECT_TYPE || '',
                defectTypeName = { "M":"Common", "C":"Call", "R":"Repair" };

            if(!SDLUtil.isNull(defectType)) {
                return defectTypeName[defectType];
            } else {
                return  '-';
            }
        },
        getGuideTypeName() {
            let guideType = this.detail.GUIDE_TYPE || '',
                guideTypeName = {"H":"H/W", "S":"S/W", "M":"Mechanical", "A":"Accessory", "I":"Info Sharing", "E":"Others"};

            if(!SDLUtil.isNull(guideType)) {
                return guideTypeName[guideType];
            } else {
                return  '-';
            }
        }
    },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'cross-editor'      : CrossEditorViewer,
    },
    methods: {
        // initiation
        initLoad() {
            Vue.$log.info('▶ KnowledgeContentsPrintPopup.vue initLoad', { KNOWLEDGE_ID: this.getKnowledgeId, mList: '', boardId: this.getBoardId });
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/knowledge/knowledgeDetail.skp`,
                    qs.stringify({ KNOWLEDGE_ID: this.getKnowledgeId, mList: '', boardId: this.getBoardId }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        // 브라우저 리사이징 이벤트
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        // Area Print
        btnPrint() {
            let w = window.open();
            w.document.write('<html><head>');
            w.document.write('<meta http-equiv="X-UA-Compatible" content="IE=edge" />');
            w.document.write('<link rel="stylesheet" href="../../../../../../static/css/common.css" type="text/css"/>');
            w.document.write('</head><body >');
            w.document.write($('.view_cont').html());
            w.document.write('</body></html>');

            setTimeout( function (){
                w.document.close();
                w.focus();
                w.print();
                w.close();
            }, 3000);
        },
        btnClose() {
            if(typeof this.rtnFunc === 'function') {
                this.rtnFunc();
            }

            this.$emit('close');
        },
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        this.initLoad().then(res => {
            Vue.$log.info("▶ KnowledgeContentsPrintPopup.vue Response => ", res);
            this.strSymptom = res.strSymptom.rowData;
            this.symptomList = res.symptomList.rowData;
            this.serialList = res.serialList.rowData;
            this.modelList = res.modelList.rowData;
            this.modelColumnName = res.modelList.columnName;
            this.partsList = res.strParts.rowData;
            this.satisfaction = res.satisfaction.rowData;
            this.attachImg = res.attachImg.rowData;
            this.detail = res.detail.rowData[0];
            this.attach = res.attach.rowData;
            this.verifyList = res.verifyList.rowData;
            this.versionList = res.version.rowData;

            // Knowledge Allow sharing 이 체크되어 있는 상태에서 법인 배포, Request Sharing 이 되지 않은 건만 버튼 활성
            this.isAllowSharing = StringUtil.strToBool(this.detail.ALLOW_SHARE);
            if(this.isRequestSharing && this.isAllowSharing) {
                let distTarget = this.detail.DIST_TARGET,
                    shareId = SDLUtil.nvl(this.detail.SHARE_ID, '');

                if(distTarget === 'S' && SDLUtil.isNull(shareId)) {
                    this.isShare = true;

                } else {
                    this.isShare = false;
                };

            } else {
                this.isShare = false;
            };

            // 즐겨찾기 확인
            try {
                if(this.detail['FAVORITE'] === 0) {
                    this.isFavorite = false;
                } else {
                    this.isFavorite = true;
                };

            } catch(e) {
                this.isFavorite = false;
            };

            // 이전 버전 존재 확인
            try {
                if(SDLUtil.isNull(this.detail['PREVIOUS_ID'])) {
                    this.isPrevious = false;
                } else {
                    this.isPrevious = true;
                };

            } catch(e) {
                this.isPrevious = false;
            }

            // SCMS 컨텐츠 확인
            let menuGroupDetailCd = this.detail['MENU_GROUP_DETAIL_CD'] || '';
            if( _.includes(SCMS_CONTENTS_CD, menuGroupDetailCd) ) {
                if(menuGroupDetailCd === 'RT') this.isRepair = true;
                this.isSCMS = true;
            };

            SDLUtil.showLoadingBar(false);
            this.isLoading = false;
        });
    },
    mounted() {
        this.$nextTick(() => {
            /*
             * RecommendPopup.vue 로 이벤트 전달 -> (param : knowledgeId)
             * Footer 하단 markup 으로 인해 SKPMain.vue로 팝업을 위치, 이벤트를 전달 한다.
             * 
             * EventBus.$emit('knowledge-recommend-show', this.getKnowledgeId);
             */
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/popup/KnowledgeContentsPrintPopup.vue